import * as THREE from "three";

const _raycaster = new THREE.Raycaster();
// Occlusion is a yes/no question — with three-mesh-bvh installed this makes
// each query stop at the first hit instead of collecting every intersection.
_raycaster.firstHitOnly = true;
const _dir = new THREE.Vector3();

// True if none of the given occluders block the segment from `from` to `to`.
// Occluders must be a flat list of static world meshes (terrain, structures);
// callers own the list so no per-query scene traversal happens here.
export function lineOfSight(from: THREE.Vector3, to: THREE.Vector3, occluders: THREE.Object3D[]): boolean {
  _dir.copy(to).sub(from);
  const dist = _dir.length();
  if (dist < 0.01) return true;
  _raycaster.set(from, _dir.normalize());
  _raycaster.near = 0.5; // don't clip the shooter's own body
  _raycaster.far = dist - 0.75; // margin so we don't hit the target itself
  return _raycaster.intersectObjects(occluders, false).length === 0;
}

// Index of the closest position to source, or -1 if positions is empty
export function nearestAliveIndex(source: THREE.Vector3, positions: THREE.Vector3[]): number {
  let best = -1;
  let bestDist = Infinity;
  for (let i = 0; i < positions.length; i++) {
    const d = source.distanceTo(positions[i]!);
    if (d < bestDist) {
      bestDist = d;
      best = i;
    }
  }
  return best;
}
